import { LayoutThemeEnum } from '../models/layout-theme.enum';
import { SiteHeaderType } from '../models/site-header-type.enum';
import { LayoutSidenav } from './layout.state.model';

export namespace LayoutActions {
  export class SetTheme {
    static readonly type = '[Layout] Set Theme';
    constructor(public theme: LayoutThemeEnum) { }
  }
  
  export class SetSidenav {
    static readonly type = '[Layout] Set Sidenav';
    constructor(public sidenav: LayoutSidenav) { }
  }

  export class ToggleSidenav {
    static readonly type = '[Layout] Toggle Sidenav';
    constructor(public open: boolean) { }
  }

  export class SetHeader {
    static readonly type = '[Layout] Set Header';
    constructor(public siteHeaderType: SiteHeaderType) { }
  }
  
  export class ResetLayout {
    static readonly type = '[Layout] Reset';
    constructor() { }
  }
}
